export const NON_STARTER_STATUS_LIST = ['AB', 'AI', 'AR', 'DB', 'DR', 'DX', 'NP', 'PG', 'RP', 'TB'];
export const STARTER_STATUS_LIST = ['DP'];